import * as React from 'react';

import { Button } from '../button/button';
import './backnextskip.style.css';

export interface TBackNextSkipProps {
  /** Css Class name to apply on back button */
  backButtonClassName?: string;
  /** Css class name to apply on next button */
  nextButtonClassName?: string;
  /** Back button display text */
  backButtonText?: string;
  /** Next button display text */
  nextButtonText?: string;
  /** Skip button display text */
  skipText?: string;
  /** Back button click event handler method name */
  onBackButtonClickHandler?: (event: any) => void;
  /** Next button click event handler method name */
  onNextButtonClickHandler?: (event: any) => void;
  /** Skip button click event handler method name */
  onSkipClickHandler?: (event: any) => void;
}

/** Back, skip next button group */
export const BackNextSkip: React.StatelessComponent<TBackNextSkipProps> = ({
  backButtonClassName,
  nextButtonClassName,
  backButtonText,
  nextButtonText,
  skipText,
  onBackButtonClickHandler,
  onNextButtonClickHandler,
  onSkipClickHandler,
}) => {
  return (
    <div className="row mt-row-btn label-text">
      <div className="col-sm-12">
        <div className="backnext-container">
          <div className="backnext-container-left">
            <Button
              text={backButtonText}
              className={backButtonClassName}
              onClick={onBackButtonClickHandler}
              name={backButtonText}
            />
          </div>
          <div className="backnext-container-right">
            <Button
              text={nextButtonText}
              className={nextButtonClassName}
              onClick={onNextButtonClickHandler}
              name={nextButtonText}
            />

            {skipText && (
              <div className="skip-container">
                <a onClick={onSkipClickHandler}> {skipText} </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

BackNextSkip.defaultProps = {
  backButtonText: 'BACK',
  nextButtonText: 'NEXT',
};
